"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MojosDAOStorageV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mojos",
        outputs: [
            {
                internalType: "contract MojosTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract IMojosDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610333806100206000396000f3fe608060405234801561001057600080fd5b50600436106100cf5760003560e01c80633932abb11161008c578063d33219b411610066578063d33219b414610272578063d8bff44014610285578063da35c66414610298578063f851a440146102a157600080fd5b80633932abb11461024d5780635c60da1b1461025657806383cce0e11461026957600080fd5b8063013cf08b146100d457806302a251a3146101cf57806314a67ea4146101e657806317977c61146101ef578063267822471461020f578063298677241461023a575b600080fd5b61015a6100e23660046102e4565b600b602081905260009182526040909120805460018201546002830154600384015460048501546009860154600a87015497870154600c880154600d890154600e9099015497996001600160a01b039097169895979496939592949192909160ff80821691610100810482169162010000909104168d565b604080519d8e526001600160a01b03909c1660208e01529a8c019990995260608b019790975260808a019590955260a089019390935260c088019190915260e08701526101008601526101208501521515610140840152151561016083015215156101808201526101a0015b60405180910390f35b6101d860055481565b6040519081526020016101c6565b6101d860065481565b6101d86101fd3660046102b4565b600c6020526000908152604090205481565b600154610222906001600160a01b031681565b6040516001600160a01b0390911681526020016101c6565b600a54610222906001600160a01b031681565b6101d860045481565b600254610222906001600160a01b031681565b6101d860075481565b600954610222906001600160a01b031681565b600354610222906001600160a01b031681565b6101d860085481565b600054610222906001600160a01b031681565b6000602082840312156102c657600080fd5b81356001600160a01b03811681146102dd57600080fd5b9392505050565b6000602082840312156102f657600080fd5b503591905056fea26469706673582212204215949731474eda8c77ddee6985a2d91d28805f759fb051c1fd2ab3694ade7164736f6c63430008060033";
const isSuperArgs = (xs) => xs.length > 1;
class MojosDAOStorageV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MojosDAOStorageV1__factory = MojosDAOStorageV1__factory;
MojosDAOStorageV1__factory.bytecode = _bytecode;
MojosDAOStorageV1__factory.abi = _abi;
